import { render, staticRenderFns } from "./DocumentationHelpModal.vue?vue&type=template&id=6613c244&scoped=true&"
import script from "./DocumentationHelpModal.vue?vue&type=script&lang=ts&"
export * from "./DocumentationHelpModal.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentationHelpModal.vue?vue&type=style&index=0&id=6613c244&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6613c244",
  null
  
)

export default component.exports